// extracted by mini-css-extract-plugin
export default {"dimmed-value":"M4GEN","dimmedValue":"M4GEN","fragments-cell":"_6RlAY","fragmentsCell":"_6RlAY","fragments":"_3WCUW"};